import { DefaultFetchService } from "app/services/fetchService";

export interface IAppSelectionResourceService {
    saveAppSelectedAndCompetingApps: (payload) => Promise<any>;
}

const fetchService = DefaultFetchService.getInstance();
const appSelectionUrl = "/connectgoogleplayaccount/save-selected-apps";

const service: IAppSelectionResourceService = {
    saveAppSelectedAndCompetingApps: function (payload) {
        return fetchService.send<any>(appSelectionUrl, {
            method: "POST",
            payload,
        });
    },
};

export default service;
